import { jsx as _jsx } from "react/jsx-runtime";
import { ProviderConnectionStatus } from "@madmedical/medical";
import { Box } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import ListItem from "../../atoms/ListItem";
import AvatarTexts from "../../molecules/AvatarTexts";
import getImage from "./getImage";
export const DeviceItem = ({ device: { provider, manufacturer, deviceName, status }, }) => {
    const { t } = useTranslation();
    return (_jsx(Box, Object.assign({ width: "full" }, { children: _jsx(ListItem, Object.assign({ link: { route: "device", params: { provider } } }, { children: _jsx(AvatarTexts, { size: "xl", isCircle: false, source: getImage(provider), label: deviceName, subText: t(`backend:${manufacturer}`), status: status === ProviderConnectionStatus.Off
                    ? undefined
                    : status }, provider) })) })));
};
